export class Logger {
  _name: string;
  _isVerbose: boolean = false;

  constructor(name: string) {
    this._name = name;
    if (typeof window !== "undefined") {
      const verbose = window.localStorage.getItem("verbose") || "false";
      this._isVerbose = verbose === "true";
    }
  }

  info(message: any) {
    if (this._isVerbose) {
      // eslint-disable-next-line no-console
      console.info(`${this._name}:`, message);
    }
  }

  error(message: any, error?: any) {
    if (this._isVerbose) {
      // eslint-disable-next-line no-console
      console.error(`${this._name}:`, message, error);
    }
  }
}
